import { IconButton, IconButtonProps, Tooltip } from '@mui/material'
import { ReactNode } from 'react'
import { Link as RouterLink } from 'react-router-dom'

interface IconRouteButtonProps extends IconButtonProps {
  children: ReactNode
  to: string
  tooltipText: string
}

export const IconRouteButton = ({
  children,
  to,
  tooltipText,
}: IconRouteButtonProps) => {
  return (
    <Tooltip title={tooltipText}>
      <IconButton component={RouterLink} to={to} color='primary'>
        {children}
      </IconButton>
    </Tooltip>
  )
}
